import { render, staticRenderFns } from "./btn-table-infos-user-alter.vue?vue&type=template&id=30fc957e&scoped=true&lang=pug&"
import script from "./btn-table-infos-user-alter.vue?vue&type=script&lang=ts&"
export * from "./btn-table-infos-user-alter.vue?vue&type=script&lang=ts&"
import style0 from "./btn-table-infos-user-alter.vue?vue&type=style&index=0&id=30fc957e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc957e",
  null
  
)

export default component.exports